import { cloneDeep, isNull } from 'lodash';
import React, { useRef } from 'react';
import { ILayerProps, IMarkupLayerProps } from '@meitu/saas-editor-core/es/version-types';
import LabelAction from '@meitu/saas-editor-ui/es/components/label-action';
import { useGlobalWidget } from '@meitu/saas-editor-ui/es/hooks/use-global-widget';
import { useListenActivePickLayerProps } from '@meitu/saas-editor-ui/es/hooks/use-listen-layer-props';
import { ColorGroup } from '@meitu/xdesign-widgets';
import { useLocaleStore } from '@/i18n';
import { editor } from '@/instance';

export const LabelBackground: React.FC<{
    id: string;
    onAfterChange?: Function;
    trackCode?: string | number;
}> = React.memo(({ id, onAfterChange, trackCode }) => {
    const { $t } = useLocaleStore();
    const oldLayer = useRef<ILayerProps | null>(null);

    const res = useListenActivePickLayerProps(editor, (layer) => {
        if (!layer) return null;
        const { label } = layer.data as IMarkupLayerProps;
        return { color: label.background };
    });

    const colorGlobalWidgetRef = useGlobalWidget(editor, false);

    if (isNull(res)) return null;

    const color = res.color;

    return (
        <div className="c-markup-panel__item">
            <LabelAction title={$t((v) => v.panel.markupPanel.background)} align={true}>
                <ColorGroup
                    onOpenChange={(e) => {
                        colorGlobalWidgetRef.current = e;
                    }}
                    popupTriggerSize={{
                        width: 78,
                        height: 34,
                    }}
                    color={color === '' ? '#00000000' : color}
                    setColor={(val) => {
                        if (oldLayer.current === null) {
                            const layer = editor.services.flatLayer.getLayer(id, true);
                            oldLayer.current = cloneDeep(layer);
                            editor.markupLayer.setAttrOperateOriginData(layer);
                        }
                        editor.markupLayer.setLabelBackground(id, val);
                    }}
                    setColorAfter={(val) => {
                        if (oldLayer.current) {
                            editor.markupLayer.setLabelBackground(id, val, oldLayer.current);
                        }
                        oldLayer.current = null;
                        editor.markupLayer.clearAttrOperateOriginData();
                        onAfterChange?.(trackCode);
                    }}
                    isGradient={false}
                    popupOverlayClassName="c-markup-panel__color-picker"
                    onToggleBizTab={(bizTab) => {
                        if (bizTab === 'team') {
                            window._stat_track?.('hb_layers_func_click', {
                                func_id: '8_107',
                            });
                        }
                    }}
                />
            </LabelAction>
        </div>
    );
});
